export const actions = {
  async nuxtServerInit({ dispatch }) {},
}
